import React from 'react';
import PropTypes from 'prop-types';
import ContentfulPicture from '../ContentfulPicture';
import PageTitle from './PageTitle';

const ImageHeader = ({ title, url, image }) => (
  <section className="image">
    <PageTitle title={title} />
    {url ? (
      <ContentfulPicture className="img-container" src={url} />
    ) : (
      <div
        className="img-container"
        style={{ backgroundImage: url ? `url(${url})` : `url(/images/${image}.jpg)` }}
      />
    )}
    <div className="title">
      <div className="container">
        <h1>{title}</h1>
      </div>
    </div>
  </section>
);

ImageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  url: PropTypes.string,
  contentful: PropTypes.boolean,
};

export default ImageHeader;
